/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlignLeft2 = createReactComponent("outline", "align-left-2", "IconAlignLeft2", [["path", { "d": "M4 4v16", "key": "svg-0" }], ["path", { "d": "M8 6h12", "key": "svg-1" }], ["path", { "d": "M8 12h6", "key": "svg-2" }], ["path", { "d": "M8 18h10", "key": "svg-3" }]]);

export { IconAlignLeft2 as default };
//# sourceMappingURL=IconAlignLeft2.mjs.map
